import { GetterTree } from "vuex";
import { RootState } from "../types";
import { answersInt } from "./types";
export const getters: GetterTree<answersInt, RootState> = {};
